/**
 * Wait for a given amount of time
 */
const wait = (milliseconds: number): Promise<void> => new Promise(resolve => setTimeout(resolve, milliseconds))

export default wait
